<template>
    <div>
        <el-form :model="shopProduct" ref="shopProductForm" :rules="rules" label-width="80px" size="mini" :inline="true">
            <el-form-item label="商品名称" prop="productName">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.productName"></el-input>
            </el-form-item>
            <el-form-item label="商品货号" prop="productNumber">
                <el-input :disabled="stateDisabled" style="width: 130px" size="small" v-model="shopProduct.productNumber"></el-input>
                <el-button
                    :disabled="stateDisabled"
                    type="primary"
                    @click="genProductNum"
                    size="small"
                    style="margin-left: 10px; width: 60px"
                    >生成</el-button
                >
            </el-form-item>
            <el-form-item label="所属店铺" prop="shopId" v-if="showShop">
                <GridSelectShop
                    style="width: 200px"
                    title="选择店铺"
                    labelName="shopName"
                    labelValue="id"
                    :value="shopProduct.shopId"
                    :limit="1"
                    size="small"
                    :disabled="stateDisabled"
                    @getValue="getValueShopId"
                    :columns="SHOP_code"
                    :searchs="SHOP_search"
                    dataListUrl="/mall/shop/findList"
                    entityBeanName="mallShop"
                    queryEntityUrl="/mall/shop/get"
                >
                </GridSelectShop>
            </el-form-item>
            <el-form-item label="商品价格" prop="shopPrice" v-if="saleMode == 1 || saleMode == 3 || (saleModeTwo == 0 && (saleMode == '' || saleMode == 2))">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.shopPrice"></el-input>
            </el-form-item>
            <el-form-item label="供货价格" prop="supplyPrice">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.supplyPrice"></el-input>
            </el-form-item>
            <el-form-item label="批发价格" prop="wholesalePrice" placeholder="请输入商品的批发价格" v-if="saleMode == 3">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.wholesalePrice"></el-input>
            </el-form-item>
            <el-form-item label="起批数量" prop="buyMinLimit" placeholder="请输入商品的起批数量" v-if="saleMode == 3">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.buyMinLimit"></el-input>
            </el-form-item>
            <el-form-item label="市场价格" prop="marketPrice">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.marketPrice"></el-input>
            </el-form-item>
            <el-form-item label="成本价格" prop="costPrice">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.costPrice"></el-input>
            </el-form-item>

            <el-form-item label="利润率" prop="profitMargin" placeholder="请输入商品的利润率">
                <el-input :disabled="true" style="width: 200px" size="small" :value="productProfitMargin"></el-input>
            </el-form-item>
			
			<!--el-form-item label="推荐手机" prop="inviterMobile">
			    <el-input :disabled="stateDisabled" placeholder="请输入商品推荐人手机" style="width: 200px" size="small" v-model="shopProduct.inviterMobile"></el-input>
			</el-form-item-->
			
			<el-form-item label="商品类目" prop="categoryId">
			    <el-select
			        :disabled="stateDisabled"
			        style="width: 200px"
			        v-model="shopProduct.categoryId"
			        placeholder="请选择"
			        clearable
			        size="small"
			    >
			        <el-tree node-key="id" :default-expanded-keys="expands" :data="shopProductCategoryList" :props="treeProps">
			            <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
			                <el-option :label="node.label" :value="data.id" :disabled="data.grade === 1 || data.grade === 2"> </el-option>
			            </div>
			        </el-tree>
			    </el-select>
			</el-form-item>

            <el-form-item label="商品分类" prop="shopCategoryId"  v-if="(showMode == 1 && showShop == 0) || showShop == 1">
                <el-select style="width: 200px" :disabled="!shopProduct.shopId || stateDisabled" v-model="shopProduct.shopCategoryId" placeholder="请选择" clearable size="small">
                    <el-tree node-key="id" :default-expanded-keys="expandss" :data="shopCategoryIds" :props="treeProps">
                        <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                            <el-option :label="node.label" :value="data.id"> </el-option>
                        </div>
                    </el-tree>
                </el-select>
            </el-form-item>
			
            <el-form-item label="商品品牌" prop="brandId">
                <GridSelect
                    style="width: 200px"
                    title="选择品牌"
                    labelName="brandName"
                    labelValue="id"
                    :value="shopProduct.brandId"
                    :limit="1"
                    :stateDisabled="stateDisabled"
                    size="small"
                    :disabled="stateDisabled"
                    placeholder="请选择品牌"
                    @getValue="getValue"
                    :columns="BRAND_code"
                    :searchs="BRAND_search"
                    dataListUrl="/shop/productbrand/findList"
                    entityBeanName="shopBrand"
                    queryEntityUrl="/shop/productbrand/get"
                >
                </GridSelect>
            </el-form-item>

            <el-form-item label="商品类型" prop="productType">
                <el-select size="small" style="width: 200px" v-model="shopProduct.productType" :disabled="stateDisabled" @change="changeProductType">
                    <el-option v-for="item of computeProductType" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="订单类型" prop="orderType" v-if="showStatus">
                <el-select size="small" style="width: 200px" :disabled="stateDisabled" v-model="shopProduct.orderType">
                    <el-option v-for="isShow in orderTypeList" :key="isShow.key" :label="isShow.value" :value="isShow.key"> </el-option>
                </el-select>
            </el-form-item>
<!--			<el-form-item label="人气指数" prop="extendField1" v-if="isProductType1">-->
<!--			    <el-input style="width: 200px" size="small" v-model="shopProduct.extendField1" :disabled="stateDisabled"></el-input>-->
<!--			</el-form-item>-->
<!--			<el-form-item label="权益价值" prop="extendField2" v-if="isProductType1">-->
<!--			    <el-input style="width: 200px" size="small" v-model="shopProduct.extendField2" :disabled="stateDisabled"></el-input>-->
<!--			</el-form-item>-->
            <el-form-item label="赠送积分" prop="giveScore" v-if="isProductType1">
                <el-input style="width: 130px" size="small" placeholder="购买标准商品赠送" v-model="shopProduct.giveScore" :disabled="stateDisabled"></el-input>
                <el-button type="primary" @click="getGiveScore" size="small" style="margin-left: 10px; width: 60px">生成</el-button>
            </el-form-item>
            <el-form-item label="所需积分" prop="productScore" v-if="shopProduct.productType == 2">
                <el-input style="width: 200px" size="small" placeholder="购买积分商品所需" v-model="shopProduct.productScore" :disabled="stateDisabled"></el-input>
            </el-form-item>
			
			<el-form-item label="商品折扣" prop="discount" v-if="isProductType1">
			    <el-input style="width: 200px" size="small" placeholder="标准商品折扣" v-model="shopProduct.discount" :disabled="stateDisabled"></el-input>
			</el-form-item>
			<el-form-item label="商品折扣" prop="scoreDiscount" v-if="shopProduct.productType == 2">
			    <el-input style="width: 200px" size="small" placeholder="积分商品折扣" v-model="shopProduct.scoreDiscount" :disabled="stateDisabled"></el-input>
			</el-form-item>
			
            <el-form-item label="结算价格" prop="settlePrice" v-if="isProductType1">
                <el-input style="width: 200px" size="small" v-model="shopProduct.settlePrice" :disabled="stateDisabled"></el-input>
            </el-form-item>
            <el-form-item label="库存数量" prop="stockSize">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.stockSize"></el-input>
            </el-form-item>
            <el-form-item label="已售数量" prop="saleSize">
                <el-input :disabled="true" style="width: 200px" size="small" v-model="shopProduct.saleSize"></el-input>
            </el-form-item>

            <el-form-item label="限购数量" prop="buyLimit">
                <el-input
                    :disabled="stateDisabled"
                    style="width: 200px"
                    size="small"
                    placeholder="请填写限购数量，0不限购"
                    v-model="shopProduct.buyLimit"
                ></el-input>
            </el-form-item>
            <el-form-item label="商品排序" prop="sort">
                <el-input-number
                    style="width: 200px"
                    v-model="shopProduct.sort"
                    size="small"
                    label=""
                    :disabled="stateDisabled"
                    :min="1"
                    :max="100"
                    :step="10"
                    :controls="true"
                    controls-position="both"
                >
                </el-input-number>
            </el-form-item>
			
            <el-form-item label="是否精选" prop="isSelected" v-if="showShop == 1">
                <el-select :disabled="stateDisabled" size="small" style="width: 200px" v-model="shopProduct.isSelected">
                    <el-option v-for="isDelicate in isShowList" :key="isDelicate.key" :label="isDelicate.value" :value="isDelicate.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否推荐" prop="isRecommend" v-if="showShop == 1">
                <el-select :disabled="stateDisabled" size="small" style="width: 200px" v-model="shopProduct.isRecommend">
                    <el-option v-for="isDelicate in isShowList" :key="isDelicate.key" :label="isDelicate.value" :value="isDelicate.key">
                    </el-option>
                </el-select>
            </el-form-item>
			
			<el-form-item label="带货佣金" prop="storeRecommend" v-if="showShop == 1">
			    <el-input style="width: 200px" size="small" placeholder="门店带货佣金" v-model="shopProduct.storeRecommend" :disabled="stateDisabled"></el-input>
			</el-form-item>
			
			<el-form-item label="分享佣金" prop="userEnjoy" v-if="showShop == 1">
			    <el-input style="width: 200px" size="small" placeholder="用户分享佣金" v-model="shopProduct.userEnjoy" :disabled="stateDisabled"></el-input>
			</el-form-item>
			
            <el-form-item label="商品状态" prop="isShow" v-if="showStatus">
                <el-select
                    :disabled="stateDisabled"
                    size="small"
                    style="width: 200px"
                    v-model="shopProduct.isShow"
                >
                    <el-option
                        v-for="isShow in productStatusEnumList"
                        :key="isShow.key"
                        :label="isShow.value"
                        :value="isShow.key"
                    > </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否包邮" prop="isFreightFree">
                <el-select :disabled="stateDisabled" size="small" style="width: 200px" v-model="shopProduct.isFreightFree">
                    <el-option
                        v-for="isFreightFree in isShowList"
                        :key="isFreightFree.key"
                        :label="isFreightFree.value"
                        :value="isFreightFree.key"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运费金额" prop="freightPrice" v-if="shopProduct.isFreightFree != 1">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" v-model="shopProduct.freightPrice"></el-input>
            </el-form-item>

            <el-form-item label="服务类型" prop="serviceType">
                <el-select
                    :disabled="stateDisabled" 
                    placeholder='请选择服务费类型'
                    clearable
                    style='width: 200px'
                    size='small'
                    v-model='shopProduct.serviceType'
                >
                    <el-option
                        v-for='(item,index) in compServiceTypeList'
                        :key='index'
                        :label='item.value'
                        :value='item.key'
                    >
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="数字资产配比" label-width="110px" prop="vbaoEnterRatio" v-if="(isGiftType && shopProduct.productType != 9) || shopProduct.productType == 1 || shopProduct.productType >= 13">
                <el-input :disabled="stateDisabled" placeholder='请输入数字资产配比' style="width: 170px" size="small" v-model="shopProduct.vbaoEnterRatio"></el-input>
            </el-form-item>

            <el-form-item label="数字凭证出局倍数" label-width="135px" prop="vbaoAutoSellMultiplier" v-if="shopProduct.productType == 1 || shopProduct.productType == 11 || shopProduct.productType >= 13">
                <el-input :disabled="stateDisabled" placeholder='请输入' style="width: 145px" size="small" v-model="shopProduct.vbaoAutoSellMultiplier"></el-input>
            </el-form-item>

            <el-form-item label="商品定位" prop="productPosition">
                <el-select
                    placeholder='请选择商品定位'
                    clearable
                    style='width: 200px'
                    size='small'
                    v-model='shopProduct.productPosition'
                    multiple
                    :disabled="stateDisabled"
                >
                    <el-option
                        v-for='(item,index) in productPositionList'
                        :key='index'
                        :label='item.value'
                        :value='item.key'
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="来源" prop="supplySource">
                <el-select
                    placeholder='请选择来源'
                    clearable
                    style='width: 200px'
                    size='small'
                    v-model='shopProduct.supplySource'
                    :disabled="true"
                >
                    <el-option label='自营' :value='0'></el-option>
                    <el-option label='聚人供应链' :value='1'></el-option>
                    <el-option label='微维宝供应链' :value='2'></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="品牌" prop="brandName">
                <el-input :disabled="stateDisabled" style="width: 200px" size="small" placeholder="请输入品牌" v-model="shopProduct.brandName"></el-input>
            </el-form-item>

            <!-- <el-form-item label="是否供应链商品" label-width="121px" prop="isSupplyChain">
                <el-select :disabled="stateDisabled" size="small" style="width: 160px" v-model="shopProduct.isSupplyChain">
                    <el-option v-for="item in isSupplyChainList" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item v-if="shopProduct.isSupplyChain == 1" label="产品名称" prop="supplyChainProduct">
                <el-input
                    :disabled="stateDisabled"
                    :readonly="true"
                    placeholder="请选择供应链产品"
                    size="small"
                    style="width: 200px"
                    v-model="shopProduct.supplyChainProduct"
                >
                    <el-button slot="append" @click="dialogVisible = true" icon="el-icon-search"></el-button>
                </el-input>
                <SelectDialog :visible="dialogVisible" name="请选择产品" @close="handleSelectDialog"></SelectDialog>
            </el-form-item> -->

            <el-form-item label="商品主图" prop="productPic">
                <el-upload
                    :disabled="stateDisabled"
                    style="width: 200px"
                    class="avatar-uploader"
                    action=""
                    :show-file-list="false"
                    :http-request="uploadAvatar"
                >
                    <img v-if="shopProduct.productPic" :src="shopProduct.productPic" class="avatar" size="small" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>

            <el-form-item label="备注" prop="storageRemark" v-if="isAdminRole || isZxkRole">
                <el-input
                    :disabled="stateDisabled"
                    type="textarea"
                    style="width: 200px"
                    :rows="5"
                    placeholder="请输入内容"
                    v-model="shopProduct.storageRemark"
                ></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import GridSelect from '@/components/gridselect';
// import SelectDialog from './SelectDialog.vue';
import { get, post, postJson, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH, SHOP, SHOP_SEARCH, BRAND, BRAND_SEARCH } from '@/utils/constant.js';
import GridSelectShop from '@/components/gridselect/gidselect.vue';

export default {
    components: {
        GridSelectShop,
        GridSelect,
        // SelectDialog
    },
    data() {
        return {
            SHOP_code: SHOP,
            SHOP_search: SHOP_SEARCH,
            BRAND_code: BRAND,
            BRAND_search: BRAND_SEARCH,
            productStatusEnumList: [], //商品状态枚举
            saleMode: 1,
            showMode: '',
            saleModeTwo: '',
            showShop: 0,
            showStatus: 0,
            orderTypeList: [],
            productType:[],
            shopProduct: {
                id: '', //Id
                productName: '', //商品名称
                productNumber: '', //商品货号
                shopPrice: '', //本店价格
                supplyPrice: '', //供货价格
                marketPrice: '', //市场价格
                buyLimit: '',
                productPic: '', //图片
                categoryId: '', //产品分组id
                brandId: '', //品牌Id
                productType: 1, //是否是积分商品
                productScore: 0, //产品所需积分
                giveScore:0,//赠送积分
				discount:1,//标准商品折扣
				scoreDiscount:1,//积分商品折扣
                sort: '10', //排序
                isShow: 1, //是否显示
                stockSize: '', //库存数量
                saleSize: '', //产品销量
                isFreightFree: 1, //是否免运费 1：是 0：否
                isSelected: 0,//是否精选
                isRecommend:0,//是否推荐
                freightPrice: '', //运费
                category: {},
                orderType: '',
                isSupply: 0,
                shopId: '',
                costPrice: 0, //成本价
				inviterMobile:'',
                shopCategoryId: '',
                buyMinLimit: '',
                wholesalePrice: '',
                serviceType: '',
                serviceRatio: '',
                isSupplyChain: 0,
                supplyChainProduct: '',
                storageRemark: '',
                vbaoEnterRatio: '',
                vbaoAutoSellMultiplier: '15',
                productPosition: [],
                brandName: ''
            },

            rules: {
                productName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                productNumber: [{ required: true, message: '商品货号不能为空', trigger: 'blur' }],
                shopPrice: [{ required: true, message: '本店价格不能为空', trigger: 'blur' }],
                supplyPrice: [{ required: true, message: '供货价格不能为空', trigger: 'blur' }],
                categoryId: [{ required: true, message: '商品类目不能为空', trigger: 'blur' }],
                costPrice: [{ required: true, message: '成本价格不能为空', trigger: 'blur' }],
                stockSize: [{ required: true, message: '库存数量不能为空', trigger: 'blur' }],
                isFreightFree: [{ required: true, message: '是否免运费不能为空', trigger: 'blur' }],
                isSelected: [{ required: true, message: '是否精选不能为空', trigger: 'blur' }],
                isRecommend: [{ required: true, message: '是否推荐不能为空', trigger: 'blur' }],
                isShow: [{ required: true, message: '是否上架不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                // saleSize: [{ required: true, message: '已售不能为空', trigger: 'blur' }],
                productPic: [{ required: true, message: '缩略图不能为空', trigger: 'blur' }],
                freightPrice: [{ required: true, message: '运费不能为空', trigger: 'blur' }],
                buyLimit: [{ required: true, message: '限购数量不能为空', trigger: 'blur' }],
                productScore: [{ required: true, message: '所需积分不能为空', trigger: 'blur' }],
                giveScore: [{ required: true, message: '赠送积分不能为空', trigger: 'blur' }],
                orderType: [{ required: true, message: '订单类型不能为空', trigger: 'blur'  }],
                productType: [{ required: true, message: '商品类型不能为空', trigger: 'blur' }],
                // shopCategoryId: [{ required: true, message: '商品分类不能为空', trigger: 'blur' }],
                wholesalePrice: [{ required: true, message: '批发价格不能为空', trigger: 'blur' }],
                buyMinLimit: [{ required: true, message: '起批数量不能为空', trigger: 'blur' }],
                serviceType: [{ required: true, message: '服务费类型不能为空', trigger: 'blur' }],
                serviceRatio: [{ required: true, message: '服务费比列不能为空', trigger: 'blur' }],
                isSupplyChain: [{ required: true, message: '是否供应链商品不能为空', trigger: 'blur' }],
                supplyChainProduct: [{ required: true, message: '产品名称不能为空', trigger: 'blur' }],
                vbaoEnterRatio: [{ required: true, message: '数字资产配比不能为空', trigger: 'blur' }],
                vbaoAutoSellMultiplier: [{ required: true, message: '数字凭证出局倍数不能为空', trigger: 'blur' }],
            },

            shopProductCategoryList: [],
            treeProps: {
                children: 'children',
                label: 'categoryName'
            },
            serviveTypeList: [],
            isShowList: [], //是否上架
            stateDisabled: false,
            expands: [],
            expandss: [],
            shopCategoryIds: [],
            isSupplyChainList: [{ key: 1, value: '是'}, { key: 0, value: '否'}],
            dialogVisible: false,
            selectDialogData: {},
            productPositionList: []
        };
    },
    computed: {
        productProfitMargin() {
            let { shopPrice, costPrice } = this.shopProduct
            let res = 0
            if(shopPrice && costPrice) {
                res = (shopPrice - costPrice) / shopPrice
                res = (res * 100).toFixed(2)
            }
            return `${res}%`
        },
        compServiceTypeList() {
            let { productType } = this.shopProduct
            if ((productType > 3 &&  productType <= 17) || productType == 1) {
                return this.serviveTypeList
            } else {
                return this.serviveTypeList.filter(item => {
                    return item.key != 0
                })
            }
        },
        isProductType1() {
            let { productType } = this.shopProduct
            return productType < 13 && productType != 2
        },
        isGiftType() {
            let { productType } = this.shopProduct
            return productType > 3 &&  productType < 13
        }
    },
    watch:{
        'shopProduct.shopId':{
            handler(newVal, oldVal) {
                this.getSaleMode()
            },immediate: true,deep: true
        },

        "shopProduct.serviceType":{
            handler(val){
                for (let i = 0; i < this.serviveTypeList.length; i++) {
                    if(this.serviveTypeList[i].key == val){
                        this.shopProduct.serviceRatio = this.serviveTypeList[i].value
                    }
                }
            }
        },

        'shopProduct.categoryId':{
            handler(val){
                if(val){
                    this.expands.push(val)
                }
            }
        },
    },
    created() {
        eventBus.$on('shopProduct', async (data, state) => {
            this.saleModeTwo = ''
            this.saleMode = 1
            // 不改变原组件的值
            console.log(data, state);
            // if(data.supplyProductCode && data.supplyProductId && data.supplySkuCode) {
            //     data.isSupplyChain = 1
            //     let res = await postJson("/supply-chain/product/advanced-search", { 
            //         proId: data.supplyProductId,
            //         proNo: data.supplyProductCode
            //     })
            //     if (res.success && res.code == 200) {
            //         const product = res.data.products[0]
            //         data.supplyChainProduct = product.title
            //         this.selectDialogData = { ...product, row: product.sku[0] }
            //     } else {
            //         this.$message({
            //             message: res.msg,
            //             type: "error",
            //             duration: 2000,
            //         });
            //     }
            // }
            this.shopProduct = { ...this.shopProduct, ...data };

            let storageRemarkList = JSON.parse(localStorage.getItem(this.$store.state.userInfo.userName + '_storageRemarkList'))

            if (storageRemarkList && storageRemarkList[data.productNumber]) {
                this.shopProduct.storageRemark = storageRemarkList[data.productNumber]
            } else {
                this.shopProduct.storageRemark = ''
            }

            console.log('this.shopProduct', this.shopProduct);
            // for (let item of this.shopProduct.skuValueList) {
            //     if (item.stock) {
            //         this.shopProduct.stockSize += item.stock;
            //     }
            // }
            console.log(this.saleModeTwo)
            this.getShopId(this.shopProduct.shopId)
            this.$forceUpdate();
            if (state == 'check') {
                this.stateDisabled = true;
            } else {
                this.stateDisabled = false;
            }

            // :disabled="shopProductState == 'check'"
        });
    },
    mounted() {
        this.getClassification();
        this.getIsShowList();
        this.getProductType();
        this.getProductStatusEnum();
        this.getShowShop();
        this.getShowStatus();
        this.getorderTypeList();
        this.getProductPositionList();
    },
    methods: {
        //是否上架
        getIsShowList() {
            get(`/mpp/utils/getEnum`, { enumType: `yes_no` }).then((res) => {
                if (res.success) {
                    this.isShowList = res.enumList;
                }
            });
        },
        getSaleMode(id){
            let obj = {}
            if(id){
                obj.shopId = id
            }
            get('/mall/shop/getSaleMode', obj).then((res)=>{
                if(res.success){
                    if(res.saleMode == 0){
                        this.saleModeTwo = res.saleMode
                        this.saleMode = ''
                        get('/mall/shop/getSaleMode', {shopId: this.shopProduct.shopId}).then((res)=>{
                            if(res.success){
                                if(res.saleMode == 0){
                                    this.saleModeTwo = res.saleMode
                                    this.saleMode = ''
                                }else{
                                    this.saleMode = res.saleMode
                                }
                            }
                        })
                    }else{
                        this.saleMode = res.saleMode
                    }
                }
            })
        },
        getShopId(id){
            let obj = {}
            if(id){
                obj.shopId = id
            }
            get('/shop/shopproductcategory/findAllAsTree',obj).then((res)=>{
                if(res.success){
                    this.shopCategoryIds = res.treeData;
                    res.treeData.forEach((element) => {
                        this.expandss.push(element.id);
                    });
                }
            })
        },
        getorderTypeList() {
            get(`/shop/utils/getEnum`, { enumType: `shop_order_type` }).then((res) => {
                if (res.success) {
                    this.orderTypeList = res.enumList;
                }
            });
        },
        getClassification() {
            get(`/shop/productcategory/findAllAsTree`).then((res) => {
                if (res.success && res.code == 200) {
                    this.shopProductCategoryList = res.treeData.map(item1 => {
                        item1.children = item1.children.map(item2 => ({ ...item2, grade: 2 }))
                        return { ...item1, grade: 1 }
                    });
                    res.treeData.forEach((element) => {
                        this.expands.push(element.id);
                    });
                }
            });
        },
        //生成货号，货号不能为空
        genProductNum() {
            let dateTime;
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth() + 1;
            let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
            dateTime = yy + '' + mm + '' + dd + '' + hh + '' + mf + '' + ss;
            this.shopProduct.productNumber = dateTime;
        },
        // 生成赠送积分
        getGiveScore(){
            let { serviceRatio, shopPrice } = this.shopProduct
            let m = {
                0.2: 1,
                0.15: 0.75,
                0.1: 0.5,
                0.05: 0.25
            }
            if (!serviceRatio || !shopPrice) {
                this.$message({
                    message: '商品价格或服务类型不能为空',
                    type: 'warning'
                });
            } else {
                let score = parseFloat(shopPrice) * m[parseFloat(serviceRatio)]
                this.shopProduct.giveScore = score.toFixed(2)
            }
        },
        // handleSelectDialog(data) {
        //     this.dialogVisible = false
        //     if(data.title && data.row) {
        //         let { title, row } = data
        //         console.log('handleSelectDialog', data)
        //         this.shopProduct.productName = title
        //         this.shopProduct.costPrice = row.supplyPrice
        //         this.shopProduct.supplyChainProduct = title
        //         this.selectDialogData = data
        //     }
        // },
        //上传缩略图
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success) {
                    this.shopProduct.productPic = res.url;
                    console.log(this.shopProduct.productPic);
                }
            });
        },
        getValueShopId(value){
            this.shopProduct.shopId = value
            this.shopProduct.shopCategoryId = ""
            this.getSaleMode(value)
            this.getShopId(value)
        },
        validateForm() {
            let flag = true;
            this.$refs.shopProductForm.validate((valid) => {
                if (valid) {
                    flag = true;
                } else {
                    console.log('error submit!!');
                    flag = false;
                }
            });
            return flag;
        },

        // ClassificationChange() {
        //     let obj = {
        //         categoryId: this.shopProduct.categoryId,
        //         brandId: this.shopProduct.brandId
        //     };

        //     eventBus.$emit('attribute', obj);
        //     eventBus.$emit('speci', obj);
        // },
        getValue(value) {
            console.log(value);
            this.shopProductCategoryList.brandId = value;
            this.shopProduct.brandId = value;

            // this.ClassificationChange();
        },
        getProductType(){
            get("/mpp/utils/getEnum",{enumType:"product_type"}).then((res)=>{
                if(res.success && res.code == 200){
                    this.productType = res.enumList
                    console.log('this.productType',this.productType);
                }
            })
        },
        // 获取商品状态枚举
        getProductStatusEnum(){
            get('/mpp/utils/getEnum',{
                enumType:'product_status',
            }).then((res)=>{
                if(res.success){
                    this.productStatusEnumList = res.enumList
                }
            })

            get('/shop/utils/getEnum', { enumType: 'shop_service_type' }).then((res) => {
                if (res.success && res.code == 200) {
                    this.serviveTypeList = res.enumList;
                }
            });
        },
        // 计算商品状态
        computeProductStatus(type){
            for (let i = 0; i < this.productStatusEnumList.length; i++) {
                if(this.productStatusEnumList[i].key == type){
                    return this.productStatusEnumList[i].value
                }
            }
        },

        // 获取showShop
        getShowShop(){
            get('/mall/shop/getShowShop').then((res)=>{
                if(res.success){
                    this.showShop = res.showShop
                    if(this.showShop == 0){
                        this.getShopId()
                        if(this.showShop == 0){
                            this.getShopId()
                            get('/mpp/utils/getShopMode').then((res)=>{
                                if(res.success){
                                    this.showMode = res.shopMode
                                }
                            })
                        }
                    }
                }
            })
        },

        //获取showStatus
        getShowStatus(){
            get('/shop/product/getShowStatus').then((res)=>{
                if(res.success){
                    this.showStatus = res.showStatus
                }
            })
        },
        getProductPositionList(){
            get('/shop/product/productPositionEnum').then((res) => {
                if (res.success && res.code == 200) {
                    this.productPositionList = res.enumList || [];
                }
            });
        },
        changeProductType(value) {
            console.log('changeProductType===================>', this.shopProduct.productType);
            if (value >= 13) {
                this.shopProduct.serviceType = 0;
            } else {
                this.shopProduct.serviceType = '';
            }
        }
    }
};
</script>
<style>
.v-modal {
    z-index: 2000 !important;
}
</style>
<style lang="scss" scoped>
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px !important;
    height: 200px !important;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
.avatarWide {
    width: 200px;
    height: 120px;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
</style>
